export const USER_ENTITIES = "USER_ENTITIES";
export const REMOVE_ENTITY = "REMOVE_ENTITY";
export const UPDATE_ENTITY_MEMBERS = "UPDATE_ENTITY_MEMBERS";
export const INIT_ENTITIES = "INIT_ENTITIES";
export const UPDATE_ENTITY = "UPDATE_ENTITY";